import React, {useState, useEffect} from 'react';
import {Row, Col, Image, Form, Button} from 'react-bootstrap';
import { Bounce } from 'react-activity';
import BackIcon from '../../../../Images/back-arrow.svg';
import HiddenPwd from '../../../../Images/hidden.svg';
import ShowPwd from '../../../../Images/show.svg';
import CardPlaceholder from '../../../../Images/card-placeholder-white.svg';
import Backend from '../../../../Backend';
import Connection from '../../../../Calls';
import {ModalSuccess} from '../Modals/ModalSuccessCard';
import { ModalContact } from '../Modals/ModalContact';

export const AddCard = (props) => {
  const [showNumber, setShowNumber] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bin, setBin] = useState('');
  const [disabled, setDisabled] = useState(true)
  const [cardImg, setCardImg] = useState('');
  const [cardType, setCardType] = useState('unknown');
  const [modal, setModal] = useState(false);
  const [modalContact, setModalContact] = useState(false);
  const [variant, setVariant] = useState("");
  
  useEffect(() => {
    setVariant("")
    if (bin.length === 19){
      requestDetectCard()
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [bin])

  const closeModalRedirect = () => {
    setModal(false)
    props.setRenderComponent("card");
    props.loadCard();
    props.getCurrentCard();
    props.transactionHistory();
  }

  const handleCloseModal = () => {
    setModal(false)
  }

  const getCardByNumber = (e) => {
    const {value} = e.target;
    if (value !== '' && value.length > 0) {
      let mask = value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
      setBin(mask)
    } else {
      setBin(value)
    }
  }

  const registerCard = () => {
    let bin_spaces = bin.replace(/\s/g, '')
    setLoading(true)
    let whiskas = Connection.RThzHrsb(bin_spaces);
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    let combination2 = Connection.RThzHrsb("XWBX203")
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var charly = response.payload.r01;
      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "1", whiskas, response => {
        Backend.VerifyCard(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r03,  charly, response => {
          if(response.status.code == '0'){
            setModal(true);
            setLoading(false);
            setVariant("success");
          } else {
            setModal(true);
            setLoading(false);
            setVariant("failed");
          }
        })
      })
    })
  }
  
  const requestDetectCard = () => {
    let bin_spaces = bin.replace(/\s/g, '')
    let whiskas = Connection.RThzHrsb(bin_spaces);
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    let combination2 = Connection.RThzHrsb("XWBX203")
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var charly = response.payload.r01;
      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "1", whiskas, response => {
        Backend.DetectCardType(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r03,  charly, response => {
          if (response.status.code == '0'){
            setCardType(response.payload.type)
            setCardImg(response.payload.image)
          }
        })
      })
    })
  }

  return (
    <div>
      <center>
        <Row style={{marginTop: '70px', marginBottom: '42px'}}>
          <Col xl={12} lg={12} style={{textAlign: 'initial', paddingLeft: '50px'}}>
            <Image className="back-navigation" src={BackIcon} onClick={() => {props.setRenderComponent("card"); props.getSlide(props.slide)}}/>
          </Col>
        </Row>
      </center>
      <center>
        {
          cardType === 'unknown' ? 
          <Image src={CardPlaceholder} width={188} height={115}/> 
          :
          <Image src={`data:image/jpeg;base64,${cardImg}`} width={188} height={115}/>
        }
      </center>
      <Row style={{ marginTop: '55px', display: 'flex', flexDirection: 'column', padding: '0px 55px'}}>
        <span style={{textAlign: 'start'}} className='add-card-title'>{props.traductions.Card.assignation.M1_title}</span>
        <div className="steps-add-wallet-general">
            <Form.Group as={Row}>
              <Col style={{textAlign: 'start'}}>
                <Form.Label className="label-card-register">{props.traductions.Card.assignation.M1_L_input}</Form.Label>
                <Form.Control
                  type={showNumber ? 'text' : 'password'}
                  value={bin}
                  placeholderText='#CCD5E2'
                  onChange={(e) => getCardByNumber(e)}
                  maxLength={19}
                
                />
                <img src={showNumber ? HiddenPwd : ShowPwd} className="eye-icon" onClick={() => setShowNumber(!showNumber)}/>
              </Col>
            </Form.Group>
          </div>
          <div>
            {
              loading ? 
              <Button disabled className="deposit-btn"><Bounce size={20} color={"#FFFFFF"} animating={true} /></Button>
                :
              <Button onClick={registerCard} style={{width: '100%'}} className={disabled ? "btn-registry-disabled" : "signup-button" } disabled={disabled}>{props.traductions.Card.enabled.btn_accept}</Button>
            }
          </div>
      </Row>
      <center>
        <div style={{height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'flex-end'}}>
          <span>{props.traductions.Card.assignation.help_text}{' /'}</span><span onClick={() => setModalContact(true)} style={{fontWeight: 'bold', color: '#242121', marginLeft: '5px', cursor: 'pointer'}}>{props.traductions.Card.assignation.contact_text}</span>
        </div>
      </center>
      <ModalSuccess variant={variant} show={modal} {...props} closeModal={closeModalRedirect} handleCloseModal={handleCloseModal} />
      <ModalContact show={modalContact} closeModal={setModalContact}  {...props} />
    </div>
  )
}
